import { PayloadAction } from '@reduxjs/toolkit';
import { ERPSystem, LanguageType } from '../../../../types';
import { LANGUAGE_ID_MAP } from '../constants';

export const reducers = {
  setErpSystem(state, action: PayloadAction<ERPSystem>) {
    state.erpSystem = action.payload;
  },
  setLanguage(state, action: PayloadAction<LanguageType>) {
    state.language = action.payload;
    state.languageId = LANGUAGE_ID_MAP[action.payload];
  },
  changeLanguage(state, action: PayloadAction<LanguageType>) {},
};
